// extracted by mini-css-extract-plugin
export var alternate = "_1d-j";
export var black = "_1d-6";
export var blue = "_1d-f";
export var blueLight = "_1d-e";
export var brand = "_1d-8";
export var darkMode = "_1d-b";
export var error = "_1d-a";
export var gray = "_1d-5";
export var grayBlue = "_1d-d";
export var iconWrapper = "_1d-3";
export var inactive = "_1d-7";
export var indigo = "_1d-g";
export var orange = "_1d-i";
export var pink = "_1d-h";
export var primary = "_1d-0";
export var purple = "_1d-9";
export var success = "_1d-4";
export var warning = "_1d-c";
export var white = "_1d-1";
export var whiteSuccess = "_1d-2";